import type { ReactNode } from 'react';
import { InfoSectionRoot, InfoSectionTitle } from './styles';

export {
  APPROVAL_SECTION_GAP,
  APPROVAL_SECTION_GAP_LG,
  infoSectionTitleStyles,
  InfoSectionRoot,
  InfoSectionTitle,
} from './styles';

type InfoSectionProps = {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
};

/** 전자결재 조회 본문의 제목 + 내용 한 묶음. 제목 없이 래퍼만 쓸 수도 있음 */
const InfoSection = ({ title, children, className }: InfoSectionProps) => (
  <InfoSectionRoot className={className}>
    {title && <InfoSectionTitle>{title}</InfoSectionTitle>}
    {children}
  </InfoSectionRoot>
);

export default InfoSection;
